import { useEffect, useState } from "react";
import { listBdcDashboardBranches } from "../../../services/bdcDashboard";
import { BdcBranch } from "../../../types/bdcDashboard.type";
import { rowsOf } from "../format";

/**
 * The BDC branches the caller may see. The branch filter is drawn only when there is more
 * than one; a failure leaves the list empty, which simply hides the filter (the page's own
 * call reports any scope error).
 */
export function useBdcBranches() {
  const [branches, setBranches] = useState<BdcBranch[]>([]);

  useEffect(() => {
    let alive = true;
    listBdcDashboardBranches()
      .then(({ data: { data } }) => {
        if (!alive) return;
        setBranches(
          rowsOf(data)
            .slice()
            .sort((a, b) => (a.branch_code ?? a.company_id).localeCompare(b.branch_code ?? b.company_id)),
        );
      })
      .catch(() => {
        if (alive) setBranches([]);
      });
    return () => {
      alive = false;
    };
  }, []);

  return branches;
}
